///<reference path="../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>

require("../node_modules/@nolimitcity/slot-game/lib/gsap/src/umd/CustomBounce.js");
require("../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.js");
import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;

import "pixi-spine";
import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {MonkeysGold} from "./game/MonkeysGold";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {MonkeysGoldIntroConfig} from "./game/intro/MonkeysGoldIntroConfig";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";

declare global {
    interface Window { NolimitLauncher: NolimitLauncher;}
}
import {MonkeysGoldPromoPanelConfig} from "./game/MonkeysGoldPromoPanelConfig";
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([ new MonkeysGold(), new NolimitSlotAudio(), new SlotKeypad(), new NolimitPromotionPlugin(new MonkeysGoldPromoPanelConfig()), new NolimitGameIntroPlugin(new MonkeysGoldIntroConfig())]);

